<template>
	<svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M39.9999 5.00001V39.9999H5.00001V5.00001H39.9999ZM39.9999 0H5.00001C3.67511 0.00386934 2.40559 0.531896 1.46874 1.46874C0.531896 2.40559 0.00386934 3.67511 0 5.00001V39.9999C0.00386934 41.3248 0.531896 42.5944 1.46874 43.5313C2.40559 44.4681 3.67511 44.9961 5.00001 45H39.9999C41.3248 44.9961 42.5944 44.4681 43.5313 43.5313C44.4681 42.5944 44.9961 41.3248 45 39.9999V5.00001C44.9961 3.67511 44.4681 2.40559 43.5313 1.46874C42.5944 0.531896 41.3248 0.00386934 39.9999 0Z"
			fill="#807B91"
		/>
	</svg>
</template>

<script>
export default {
	name: 'b-icon-check-box-outline-blank',
	components: {},
	computed: {},
	props: {}
};
</script>

<docs>
    BIconCheckBoxOutlineBlank

    ```js
    <b-icon-check-box-outline-blank />
    ```
</docs>